import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMinus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M256-428q-22 0-37-15t-15-37q0-22 15-37t37-15h448q22 0 37 15t15 37q0 22-15 37t-37 15H256Z" })
});
export default SvgMinus;
